import React from 'react'
//

const CareersBodySection = ({ title, body }) => (
  <div className="c-careers__body l-grid l-grid--default-spacing">
    <div className="s-wysiwyg-editor s-wysiwyg-editor--simple l-grid__col:12/12">
      {title && <h3>{title}</h3>}
      {body && <div dangerouslySetInnerHTML={{ __html: `<div>${body}</div>` }} />}
    </div>
  </div>
)

export default CareersBodySection
